const translate = (intl, message) => {
  if (intl && intl.formatMessage) {
    return intl.formatMessage(message);
  }

  return message.defaultMessage;
};

export default translate;
